import { fetchQuery } from '@/services/messaging/fetchQuery';

export function getSignees(treatmentAreaId) {
  return fetchQuery("GetSignees", { treatmentAreaId });
}
